import React, { useState } from 'react';

import { useRouter } from 'next/router';

import { generateAndDeployToken } from '@/api/generateAndDeployToken';
import { Popup } from '@/components/Popup/Popup';
import useMediaQuery from '@/hooks/useMediaQuery';
import { sendNotifcation } from '@/utils/notification';

import { AirDropStatus } from './AirDropStatus';
import TokenCreationStep1 from './TokenCreationStep1';
import TokenCreationStep2 from './TokenCreationStep2';

export default function TokenCreationV2({
  setSuccessfulAirdrop,
  setCreateTokenWithAddress,
}: {
  setSuccessfulAirdrop: Function;
  setCreateTokenWithAddress: Function;
}) {
  const isMediaMax1025px = useMediaQuery('(max-width : 1025px)');
  const [step1Complete, setStep1Complete] = useState<boolean>(false);
  const [AudUUID, setAudUUID] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tokenName, setTokenName] = useState<string>('');
  const [tokenSymbol, setTokenSymbol] = useState<string>('');
  const [file, setFile] = useState<File>(null);
  const [tokenLogo, setTokenLogo] = useState<File>(null);
  const [tokenDescription, setTokenDescription] = useState('');
  const [addresses, setAddresses] = useState<string>('');
  const router = useRouter();

  const handleUpload = async () => {
    setIsLoading(true);
    if (addresses === '' && file === null) {
      setIsLoading(false);
      sendNotifcation(
        'Cannot deploy token to an empty address list',
        ' ',
        'danger'
      );
      return;
    }
    let addressList;
    if (addresses.length) {
      addressList = addresses.trim().split(',');
      addressList = addressList.map((address) => address.trim());
    }
    const { fileId } = router.query;
    try {
      const res = await generateAndDeployToken(
        file,
        file ? null : addressList,
        fileId.toString(),
        tokenName,
        tokenSymbol,
        tokenDescription,
        tokenLogo
      );
      setAudUUID(res.data.audience.uuid);
    } catch (err) {
      sendNotifcation('Some Error Occurred', '', 'danger');
    } finally {
      setIsLoading(false);
      setFile(null);
      setAddresses('');
    }
  };

  return (
    <Popup
      isOpen={true}
      margin={isMediaMax1025px ? '90px 5%' : '70px auto'}
      width={isMediaMax1025px ? null : '850px'}
      height={isMediaMax1025px ? '32rem' : '465px'}
      closePopup={() => {}}
    >
      <div className={`max-w-full h-full box-border`}>
        {!step1Complete && (
          <TokenCreationStep1
            setStep1Complete={setStep1Complete}
            tokenName={tokenName}
            setTokenName={setTokenName}
            tokenSymbol={tokenSymbol}
            tokenLogo={tokenLogo}
            setTokenLogo={setTokenLogo}
            tokenDescription={tokenDescription}
            setTokenDescription={setTokenDescription}
            setTokenSymbol={setTokenSymbol}
            setCreateTokenWithAddress={setCreateTokenWithAddress}
          />
        )}
        {step1Complete && !AudUUID && (
          <TokenCreationStep2
            setStep1Complete={setStep1Complete}
            file={file}
            setFile={setFile}
            addresses={addresses}
            setAddresses={setAddresses}
            handleUpload={handleUpload}
            isLoading={isLoading}
          />
        )}
        {AudUUID && (
          <AirDropStatus
            AudUUID={AudUUID}
            setSuccessfulAirdrop={setSuccessfulAirdrop}
          />
        )}
      </div>
    </Popup>
  );
}
